module.exports = __webpack_public_path__ + "static/media/hp_1.fa44146c.png";